import { CrownIcon } from '../../Icons/CrownIcon'

export const PremiumBadge = ({ size = 'md' }) => (
  <div
    style={{ backgroundColor: '#C75146' }}
    className={`d-inline-flex align-items-center me-2 ${
      size === 'md' ? 'px-2 py-1 rounded' : 'badge'
    }`}
  >
    <div
      style={{ backgroundColor: '#9C3228' }}
      className='p-1 rounded-circle d-inline-block me-2 d-inline-flex align-items-center justify-content-center'
    >
      <CrownIcon color='#F9B533' height='10' width='9' />
    </div>
    <span
      style={{ fontSize: size === 'md' ? '0.75rem' : '0.6rem' }}
      className='text-white fw-bold'
    >
      Premium
    </span>
  </div>
)
